import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../Baseurl";

const DeliveryCharges = ({
  delivery_method,
  standard_delivery_charge,
  distance_based_charges,
  origin_pincode, delivery_notes
}) => {
  const [userPincode, setUserPincode] = useState("");
  const [estimatedCharge, setEstimatedCharge] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    console.log("Delivery Method:", delivery_method);
    console.log("Standard Delivery Charge:", standard_delivery_charge);
    console.log("Distance Based Charges:", distance_based_charges);
    console.log("Origin Pincode:", origin_pincode);
  }, [delivery_method, standard_delivery_charge, distance_based_charges, origin_pincode]);

  const handlePincodeCheck = async () => {
    if (!userPincode || !origin_pincode) {
      Swal.fire("Error", "Please Enter Your Pincode.", "error");
      return;
    }
    setLoading(true); // Start loading
    try {
      const distRes = await axios.get(`${baseurl}distancePincode/${origin_pincode}/${userPincode}`);
      const { success, distance_km } = distRes.data;

      if (!success || !distance_km) {
        throw new Error("Invalid distance response");
      }

      const distance = parseFloat(distance_km);
      console.log("Fetched Distance (km):", distance);

      let matchedTier = distance_based_charges
        .sort((a, b) => a.within_km - b.within_km)
        .find(tier => distance <= tier.within_km);

      if (!matchedTier) {
        // fallback to the highest tier
        matchedTier = distance_based_charges.reduce((prev, curr) =>
          prev.within_km > curr.within_km ? prev : curr
        );
      }

      const charge = matchedTier.charge;
      setEstimatedCharge(charge);

      const dataToSend = {
        user_pincode: userPincode,
        origin_pincode,
        estimated_charge: charge,
        delivery_method,
      };

      console.log("Sending to backend:", dataToSend);
      // You can optionally send this to your backend if needed
      // await axios.post(`${baseurl}/api/saveDeliveryCheck`, dataToSend);

    } catch (error) {
      console.error("Failed to check or save delivery info:", error);
      Swal.fire("Error", "Could not check delivery info", "error");
    }
    setLoading(false); // End loading
  };

  const handleClear = () => {
    setUserPincode("");
    setEstimatedCharge(null);
  };

  return (
    <div className="card p-2 border rounded mb-3">
      {delivery_method === "standard" && (
        <p><strong>Standard Delivery Charge:</strong> ₹{standard_delivery_charge}&nbsp; 
        <span className=""><i>({delivery_notes})</i></span>
        </p>
      )}

      {delivery_method === "distance" && (
        <>
          <p><strong>Enter your Pincode to check delivery charges:</strong></p>
          <div className="d-flex gap-2 mb-2">
            <input
              type="number"
              className="form-control"
              placeholder="Enter your pincode"
              value={userPincode}
              onChange={(e) => setUserPincode(e.target.value)}
            />
            <button className="btn btn-primary" onClick={handlePincodeCheck} disabled={loading}>
              {loading ? "Checking..." : "Check"}
            </button>
            <button className="btn btn-outline-secondary" onClick={handleClear}>
              Clear
            </button>
          </div>

          {estimatedCharge !== null && (
            <div className="alert alert-info text-dark ">
              {estimatedCharge === 0
                ? "Free delivery!"
                : `Estimated Delivery Charge: ₹${estimatedCharge}`}
            </div>
          )}
        </>
      )}

      {delivery_method === "free" && (
        <p className="text-success"><strong>Delivery is free!</strong></p>
      )}
    </div>
  );
};

export default DeliveryCharges;
